module.exports = __webpack_public_path__ + "img/carta.587696c5.svg";